import MockAdapter from "axios-mock-adapter";
// import authAdaptor from "../modules/auth/__mocks__/adapter";
// import productAdaptor from "../modules/products/__mocks__/adapter";
// import linksAdaptor from "../modules/links/__mocks__/adapter";
// import ordersAdaptor from "../modules/orders/__mocks__/adapter";
// import QNAAdaptor from "../modules/qna/__mocks__/adapter";
// import sampleAdaptor from "../modules/samples/__mocks__/adapter";
// import sellersAdaptor from "../modules/sellers/__mocks__/adapter";
// import categoriesAdaptor from "../modules/categories/__mocks__/adapter";
import balancesAdaptor from "../modules/balances/__mocks__/adapter";

export default function mockAxios(axios) {
  const adapter = new MockAdapter(axios, { delayResponse: 300 });

  // authAdaptor(adapter);
  // productAdaptor(adapter);
  // linksAdaptor(adapter);
  // ordersAdaptor(adapter);
  // QNAAdaptor(adapter);
  // sampleAdaptor(adapter);
  // sellersAdaptor(adapter);
  // categoriesAdaptor(adapter);
  balancesAdaptor(adapter);

  return adapter;
}
